// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WGvTP","colBig":"styles_colBig__t_k9t","colSmall":"styles_colSmall__1BqI6"};